import { ADD_VIDEO_OPTIONS } from "repoV2/pages/sale/constants";
import { ISalePageSectionsDataFromApi } from "./getSalePageTemplateDataApi.interfaces";

interface IUnpocessedBonusesListFromApi {
    title: string;
    description: string;
    image: string;
    price: string;
}
export const getPocessedBonusesListFromApi = (
    data: Array<IUnpocessedBonusesListFromApi> = []
): ISalePageSectionsDataFromApi["bonusesSection"]["bonusesList"] =>
    data.map(
        (
            j: IUnpocessedBonusesListFromApi = {} as IUnpocessedBonusesListFromApi
        ) => ({
            title: j.title,
            description: j.description,
            imgSrc: j.image,
            worth: j.price,
        })
    );

interface IUnpocessedTestimonialsListFromApi {
    name: string;
    image: string;
    sub_heading: string;
    description: string;
    testimonial_type?: string;
    testimonial_img?: string;
    testimonial_thumb_url?: string;
    testimonial_video_url?: string;
    testimonial_video_upload_url?: string;
    testimonial_video_embed_code?: string;
    video_upload_type?: string;
}
export const getPocessedTestimonialsListFromApi = (
    data: Array<{ data: IUnpocessedTestimonialsListFromApi }> = []
): ISalePageSectionsDataFromApi["testimonialsSection"]["testimonialsList"] =>
    data.map((j = {} as { data: IUnpocessedTestimonialsListFromApi }) => {
        const itemData = j.data || ({} as IUnpocessedTestimonialsListFromApi);
        const { video_upload_type = ADD_VIDEO_OPTIONS.ADD_LINK.slug } =
            itemData;
        let videoSrc;
        switch (video_upload_type) {
            case ADD_VIDEO_OPTIONS.UPLOAD_VIDEO.slug:
                videoSrc = itemData.testimonial_video_upload_url;
                break;
            case ADD_VIDEO_OPTIONS.ADD_LINK.slug:
                videoSrc = itemData.testimonial_video_url;
                break;
            case ADD_VIDEO_OPTIONS.ADD_EMBED_CODE.slug:
                videoSrc = itemData.testimonial_video_embed_code;
                break;
            default:
                break;
        }
        return {
            reviewerName: itemData.name,
            reviewerImgSrc: itemData.image,
            reviewContent: itemData.description,
            testimonialType: itemData.testimonial_type,
            testimonialImgSrc: itemData.testimonial_img,
            testimonialThumbUrl: itemData.testimonial_thumb_url,
            testimonialVideoSrc: videoSrc,
            testimonialVideoSrcType: video_upload_type,
        };
    });

interface IUnpocessedFeaturedInListFromApi {
    organisation_name: string;
    media_logo: string;
}
export const getPocessedFeaturedInListFromApi = (
    data: Array<IUnpocessedFeaturedInListFromApi> = []
): ISalePageSectionsDataFromApi["featuredInSection"]["featuredInList"] =>
    data.map((j = {} as IUnpocessedFeaturedInListFromApi) => ({
        title: j.organisation_name,
        imgSrc: j.media_logo,
    }));

interface IUnprocessedCustomPromoStatsListFromApi {
    title: string;
    description: string;
    image: string;
}

export const getProcessedCustomPromoStatsListFromApi = (
    data: Array<IUnprocessedCustomPromoStatsListFromApi> = []
): ISalePageSectionsDataFromApi["customPromoStatsSection"]["customPromoStatsList"] =>
    data.map((j = {} as IUnprocessedCustomPromoStatsListFromApi) => ({
        title: j.title,
        description: j.description,
        imgSrc: j.image,
    }));
interface IUnprocessedCustomHighlightsListFromApi {
    title: string;
    description: string;
    image: string;
}

export const getProcessedCustomHighlightsListFromApi = (
    data: Array<IUnprocessedCustomHighlightsListFromApi> = []
): ISalePageSectionsDataFromApi["customHighlights"]["customHighlightsList"] =>
    data.map((j = {} as IUnprocessedCustomHighlightsListFromApi) => ({
        title: j.title,
        description: j.description,
        imgSrc: j.image,
    }));

interface IUnprocessedGalleryImgList {
    id: number | string;
    value: { img_src: string };
}

export const getProcessedGalleryImgListFromApi = (
    data: Array<IUnprocessedGalleryImgList> = []
): ISalePageSectionsDataFromApi["gallerySection"]["galleryImgList"] =>
    data.map((j = {} as IUnprocessedGalleryImgList) => ({
        imgSrc: j.value.img_src,
    }));

interface IUnprocessesContentOutlineList {
    title: string;
    subTitle: string;
    description: string;
    image: string;
}

export const getProcessedContentOutlineListFromApi = (
    data: Array<IUnprocessesContentOutlineList> = []
): ISalePageSectionsDataFromApi["contentOutline"]["contentOutlineList"] =>
    data.map((j = {} as IUnprocessesContentOutlineList) => ({
        title: j.title,
        subTitle: j.subTitle,
        description: j.description,
        imgSrc: j.image,
    }));

interface IUnprocessedCrossDataShowcaseListFromApi {
    title: string;
    description: string;
    showcaseImgSrc: string;
    pointersTitle: string;
    pointers: Array<string>;
}

export const getProcessedCrossDataShowcaseListFromApi = (
    data: Array<{ data: IUnprocessedCrossDataShowcaseListFromApi }> = []
): ISalePageSectionsDataFromApi["crossDataShowcase"]["showcaseList"] =>
    data.map((j = {} as { data: IUnprocessedCrossDataShowcaseListFromApi }) => {
        const itemData =
            j.data || ({} as IUnprocessedCrossDataShowcaseListFromApi);
        return {
            title: itemData.title,
            description: itemData.description,
            showcaseImgSrc: itemData.showcaseImgSrc,
            pointersTitle: itemData.pointersTitle,
            pointers: itemData.pointers,
        };
    });

interface IUnprocessedDemoVideoHighlightsListFromApi {
    imgSrc: string;
    description: string;
}
export const getProcessedDemoVideoHighlightsListFromApi = (
    data: Array<IUnprocessedDemoVideoHighlightsListFromApi> = []
): ISalePageSectionsDataFromApi["demoVideoHighlights"]["highlightsList"] =>
    data.map((j = {} as IUnprocessedDemoVideoHighlightsListFromApi) => ({
        imgSrc: j.imgSrc,
        description: j.description,
    }));
